import React from 'react';

function createCtx<T>() {
  const ctx = React.createContext<T | undefined>(undefined);
  function useCtx() {
    const value = React.useContext(ctx);
    if (!value) throw new Error('useCtx must be inside a Provider with a value');
    return value;
  }
  return [useCtx, ctx.Provider] as const;
}

export default createCtx;
